/**
 * @format
 * @module lib/commercial/keytar/newsletters/template
 */
import Template, { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import { loginAnchorClick } from "ui/login";
import { registerAnchorClick } from "ui/register";
import consts from "lib/consts";
import { addParamToUrl, qs } from "utils/utils";

const blockoutType = BLOCKOUT_TYPES.NOTHING;

const props = {
  blockoutType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    const subHeading = qs("#title-content-area .c-static-page__heading");
    const menuLink = qs("#title-content-area .o-menu__item:first-child");
    const cardContainer = qs("#main-content-area > .l-row > .pb-container");

    const campaign = "newsletters";
    const loginUrl = addParamToUrl(consts.URLS.LOGIN, campaign);
    const registerUrl = addParamToUrl(consts.URLS.REGISTER.BASE, campaign);

    if (subHeading && menuLink && cardContainer) {
      const markup = `
        <div class="arc-newsletter-wall__message pb-container">
          <h2 class="arc-newsletter-wall__heading">Register for free to access our email newsletters</h2>
          <p class="arc-newsletter-wall__text">If you already have an account please login</p>
          <div class="arc-newsletter-wall__buttons">
            <a href="${registerUrl}" class="c-button c-button--utility-green-primary js-newsletter-wall-register">
              <span class="c-button__text">Register today</span>
            </a>
            <a href="${loginUrl}" class="c-button c-button--white-secondary js-newsletter-wall-login">
              <span class="c-button__text">Log in</span>
            </a>
          </div>
        </div>
      `;
      subHeading.classList.add("u-hidden");
      menuLink.classList.add("u-hidden");
      cardContainer.classList.add("arc-newsletter-wall__cards");
      cardContainer.insertAdjacentHTML("beforebegin", markup);

      const registerButton = qs(".js-newsletter-wall-register");
      const loginButton = qs(".js-newsletter-wall-login");
      registerButton &&
        registerButton.addEventListener("click", e =>
          registerAnchorClick(e, "newsletters-welcome")
        );
      loginButton &&
        loginButton.addEventListener("click", e => loginAnchorClick(e, "newsletters-welcome"));
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
